<ion-text *ngIf="errorMessage" color="danger" class="error-message">
  {{ errorMessage }}
</ion-text>
